import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import { PagedResultDto_PoolListDto, PoolService } from '../../services/wealthlane-award-services';

const useGetSharePoolList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // vestingTypeIds?: string[]
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PoolListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const sharePoolList = useQuery(
    ['getSharePoolList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        PoolService.getApiAwardApiAppPoolPoolList(filter, sorting, skipCount, maxResultCount)
      );
    }
  );

  return sharePoolList;
};

export default useGetSharePoolList;
